/**
 * Pulsante "← Indietro" globale.
 *
 * Comportamento:
 *  - Usa la cronologia di navigazione del browser quando disponibile
 *    (`navigate(-1)`) — questo è il default e copre quasi tutti i casi.
 *  - Se non c'è una pagina precedente (es. apertura diretta del link, deep link
 *    da WhatsApp / email), naviga alla pagina indicata da `fallback`
 *    (default `/dashboard` per le pagine gestionali; chi lo usa nelle pagine
 *    pubbliche imposta `fallback="/home"`).
 *  - Variante `floating`: bottone tondo semi-trasparente posizionato in
 *    alto a sinistra sopra una hero image (usato in ProductDetailPage /
 *    ShopPage).
 *  - Variante `inline` (default): pulsante con etichetta sotto l'header.
 */
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function BackButton({
  fallback = '/dashboard',
  variant = 'inline',
  label = 'Indietro',
  className = '',
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    // history.length > 1 means we have somewhere to go back to (within this tab).
    // Otherwise navigate to the explicit fallback.
    if (window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };

  if (variant === 'floating') {
    return (
      <button
        type="button"
        onClick={handleClick}
        className={`absolute top-4 left-4 z-20 w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm shadow-md hover:bg-white hover:shadow-lg flex items-center justify-center transition-all ${className}`}
        aria-label={label}
        data-testid="back-button"
      >
        <ArrowLeft className="w-6 h-6 text-slate-700" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100 px-3 py-1.5 rounded-lg transition-colors ${className}`}
      data-testid="back-button"
    >
      <ArrowLeft className="w-4 h-4" />
      {label}
    </button>
  );
}
